<template>
  <div id="data-view">
    <dv-full-screen-container>

      <!-- 顶部 -->
      <top-header />
      <topTrim />

      <div class="main-content">
        <div class="block-left-right-content">
          <div class="block-top-bottom-content">
            <div class="block-top-content">
              <!-- 中部 -->
              <centralInfo />

            </div>
            <div class="block-top-content">
              <!-- 底部 -->
              <bottomInfo />

            </div>
          </div>
        </div>
      </div>
    </dv-full-screen-container>
  </div>
</template>

<script>
import topHeader from './topHeader'
import centralInfo from './centralInfo'
import topTrim from './topTrim'
import bottomInfo from './bottomInfo'

export default {
  name: 'DataView',
  components: {
    topHeader,
    centralInfo,
    topTrim,
    bottomInfo
  },
  data () {
    return {}
  },
  methods: {}
}
</script>

<style lang="less">
#data-view {
  width: 100%;
  height: 100%;
  background-color: #030409;
  color: #fff;

  #dv-full-screen-container {
    background-image: url('./img/bg.png');
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }

  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .block-left-right-content {
    flex: 1;
    display: flex;
    margin-top: 20px;
  }

  .block-top-bottom-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;
  }

  .block-top-content {
    height: 54%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
  }
}
</style>
